import styled from 'styled-components';

import { Body } from '../../../styles/fonts';

export const Text = styled(Body).attrs({ weight: 'regular' })`
  color: rgba(0, 0, 0, 0.7);
`;
